
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout-list",
      function () {
        return require("private-next-pages/ai-optout-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout-list"])
      });
    }
  